export default {
  engagementModerationReasons(state) {
    return state.engagementModerationReasons;
  },
};
